<template>
  <div class="listPage" id="newList">
    <Crumbs title="新闻管理" />
    <div class="query-bar">
      <el-row>
        <el-col :span="6">
          <enumerate
            url="/api/News/GetNewsType"
            v-model="queryCondition.typeId"
            placeholder="新闻分类"
          />
        </el-col>
        <el-col :span="10">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="发布开始时间"
            end-placeholder="发布结束时间"
            value-format="yyyy-MM-dd"
            style="width:100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="queryCondition.title"
            clearable
            placeholder="请输入关键字"
          >
          </el-input>
        </el-col>
        <el-col class="flush-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <el-row class="toolbar">
      <el-col :span="12">
        <el-button
          type="warning"
          icon="el-icon-circle-plus"
          @click="redirectByPath(`/newInfo/addition`)"
          >添加
        </el-button>
        <el-button
          type="warning"
          icon="el-icon-delete"
          @click="handleBatchDelete"
          >删除</el-button
        >
      </el-col>
    </el-row>

    <div
      class="query-table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <div>
        <el-table
          :data="queryList"
          @selection-change="handleSelectionChange"
          border
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column prop="id" label="新闻id" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="新闻标题"
            show-overflow-tooltip
            class-name="clickableLink"
          >
            <template slot-scope="scope">
              <a href="javascript:;" @click="handleLook(scope.row)">{{
                scope.row.title
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="新闻分类"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column label="发布时间" width="90" align="center">
            <template slot-scope="scope">
              <p>
                {{ scope.row.createTime.trim().split(/\s+/)[0] }}
              </p>
              <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isTop"
                size="mini"
                type="primary"
                @click="handleTop(scope.row)"
                icon="el-icon-top"
                circle
              ></el-button>
              <el-button size="mini" @click="handleLook(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flush-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Crumbs from "@/components/crumbs";
import Enumerate from "@/components/enumerate";
export default {
  name: "newList",
  created() {
    this.loadList();
  },
  data() {
    return {
      //查询条件
      queryCondition: {
        typeId: "",
        publishDate: [],
        title: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  methods: {
    //出来参数
    processParams() {
      let { title, pageIndex, pageSize } = this.queryCondition,
        mixin = {
          typeId: ""
        },
        [publishStart = "", publishEnd = ""] =
          this.queryCondition.publishDate || [];
      Object.keys(mixin).map(item => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        title,
        pageIndex,
        pageSize,
        ...mixin,
        publishStart,
        publishEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.requestApi("newList", "getList", this.processParams(), res => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击置顶
    handleTop(row) {
      const { id } = row;
      this.requestApi("newList", "setTop", { id }, res => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击查看
    handleLook(row) {
      const { id } = row;
      this.redirectByPath(`/newInfo/modification`, {
        id
      });
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map(item => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.requestApi("newList", "batchDelete", idList, res => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  },
  components: {
    Crumbs,
    Enumerate
  }
};
</script>

<style></style>
